import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 10px 12px;
  border-radius: 15px;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -6px #252525;
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px;
  gap: 8px;
`

export const ScheduleInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #F7F7F7;
  border: 1px solid #DDDDDD;
  border-radius: 10px;
  padding-left: 10px;
  gap: 10px;
`

export const Image = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  margin-left: 10px;
`

export const PlusIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  background-color: #FFFFFF;
  border: 1px solid #DDDDDD;
  margin: -20px 0px;
  border-radius: 50%;
  z-index: 5;
`

export const InfoText = styled.p`
  color: #252525;
  font-size: 14px;
  text-align: left;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 18px;
  font-weight: bold;
  padding: 0px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`
